module.exports = __webpack_public_path__ + "img/section-01@2x.406dc575.png";